/**
 * Created by saionara1 on 6/21/17.
 */

// @flow
export default {
  EMAIL_REGEX:  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  WEB_PAGES_URL: "http://game.sweitinfotech.com/pages/",
  API_URL: "http://api-game.sweitinfotech.com/v1.0/",
  WEB_URL: "http://game.sweitinfotech.com/",
  API_BLOGS_URL: "http://api-game.sweitinfotech.com/",
  CLIENT_ID: 'ffb12e79140e7b6597ba',
  CLIENT_SECRET: 'd07dadbce095325cebfc40a46eb467e906063927',
  API_HEADER: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  BASE_PAGE_LIMIT: 4,
  BLOG_LIMIT: 20,
  LOGIN_SCREEN: 'Login',
  REPOSITORY_LIST_SCREEN: 'RepositoriesList',
  REPOSITORY_DETAILS_SCREEN: 'RepositoryDetails',
  HARDWARE_PRESS_EVENT:'hardwareBackPress',
}